import { render, staticRenderFns } from "./KioskSettings.vue?vue&type=template&id=35ed54ca&scoped=true&"
import script from "./KioskSettings.vue?vue&type=script&lang=js&"
export * from "./KioskSettings.vue?vue&type=script&lang=js&"
import style0 from "./KioskSettings.css?vue&type=style&index=0&id=35ed54ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ed54ca",
  null
  
)

export default component.exports